<div fxLayout="row" fxLayoutGap="8px" [cdkTrapFocus]="notificationType !== notificationTypes.SUCCESS" [cdkTrapFocusAutoCapture]="notificationType !== notificationTypes.SUCCESS">
  <div>
    <mat-icon [ngClass]="notificationType === notificationTypes.SUCCESS ? 'check-circle-outline-icon' : 'error-outline-icon'">
      {{notificationType === notificationTypes.SUCCESS ? 'check_circle_outline' : 'error_outline'}}
    </mat-icon>
  </div>
  <div class="message">
    <div class="notification-message"
      [matTooltip]="notificationMessage"
      [ngClass]="{'no-detail-error-message': detailedErrorMessages.length === 0}"
      tabindex="0">
      {{notificationMessage}}
    </div>
    <ng-container *ngIf="detailedErrorMessages.length > 0">
      <div class="detailed-error-message"
        [matTooltip]="detailedErrorMessages[0] | capitalizeFirstLetter"
        tabindex="0">
        {{detailedErrorMessages[0] | capitalizeFirstLetter}}
      </div>
    </ng-container>
  </div>
  <div *ngIf="notificationType !== notificationTypes.SUCCESS">
    <mat-icon class="close-icon"
      #closeIcon
      tabindex="0"
      (keydown.enter)="$event.target.click()"
      (keydown.space)="$event.target.click(); $event.preventDefault()"
      (click)="dismissNotificationSnackbar()">close</mat-icon>
  </div>
</div>
